import styled from 'styled-components';
import { darken } from '@mui/material';
import { createGradientOrSolid } from 'utils';

export const PokerFaceSpecialOfferButton = styled.div`
  width: 126px;
  height: 30px;
  border: 1px solid;
  border-color: ${(props: any) => darken(props.borderColor || '#000000', 0.3)};
  border-radius: 4px;
  background: ${(props: any) => createGradientOrSolid(props.backgroundColor)};
  position: absolute;
  bottom: 8px;
  direction: ${(props: any) => props.direction};

  .container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 2px solid;
    border-color: ${(props: any) =>
      darken(props.backgroundColor?.colorOne || '#000000', 0.3)};
    border-radius: 3px;
    box-shadow: inset 0 0 3px #ffffff;

    span {
      color: ${(props: any) => props.textColor};
      font-size: 16px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      text-shadow: 0 2px 1px #004100;
    }

    .stroked {
      & > span {
        font-size: 12px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        text-shadow: none;
      }
    }
  }
` as any;
